import './App.css'
import Header from './Header/Header'
import Heading from './Heading/Heading'
import Misc from './Misc/Misc';

function App() {
  return (
    <div className="App">
        <Header />
        <Heading />
        <Misc />
    </div>
  );
}

export default App;
